import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export const buildRedirectWithSearchTarget = (to, search = "") => `${to}${search || ""}`;

const RouteRedirectWithSearch = ({ to }) => {
  const location = useLocation();
  return <Navigate to={buildRedirectWithSearchTarget(to, location.search)} replace />;
};

export default RouteRedirectWithSearch;
